import { render, staticRenderFns } from "./UserNavbar.vue?vue&type=template&id=e051f90c&scoped=true&"
import script from "./UserNavbar.vue?vue&type=script&lang=js&"
export * from "./UserNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e051f90c",
  null
  
)

export default component.exports